const state = {
    data: {}
}

const getters = {
    getDataConnectLine() {
        return state.data;
    }
}

const mutations = {
    async setDataConnectLine(data) {
       let dataEvent = data.split('||');

       state.data = {
            queue: dataEvent[0],
            name: dataEvent[1],
            phone: dataEvent[1],
            protocol: dataEvent[2],
            type: 'phone'
       }
       return state.data;
    },

    async delDataConnectLine() {
        state.data = {}
    },

    async setChatData(data){
        state.data = {
            protocol: data.protocol, 
            phone: data.phone,
            type: 'chat',
            name: data.name,
            queue: data.queue
        };
        return state.data;
    }
}

export default {
    state,
    getters,
    mutations
}
